import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { DataViewService } from '@ib-shared/services/data-view.service';
import { DATA_TYPE, DATE_VIEW_TYPE } from '@ib-shared/types/data.type';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'ib-data-view',
  templateUrl: './data-view.component.html',
  styleUrls: ['./data-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataViewComponent implements OnInit {
  @Input() dataType: DATA_TYPE;
  @Input() set val(v: string | number) {
    this.val$.next(v);
  }
  @Input() dateView: DATE_VIEW_TYPE;

  public valUi$: Observable<string | number>;
  private val$ = new BehaviorSubject<string | number>(undefined);

  constructor(private dataViewS: DataViewService) {}

  ngOnInit(): void {
    this.valUi$ = this.dataViewS.getObsByType({
      dataType: this.dataType,
      dateView: this.dateView,
      val$: this.val$,
    });
  }
}
